import { render, staticRenderFns } from "./TaskCreateDialog.vue?vue&type=template&id=56c8fbea&scoped=true"
import script from "./TaskCreateDialog.vue?vue&type=script&lang=ts"
export * from "./TaskCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c8fbea",
  null
  
)

export default component.exports